import React from 'react';
import {getConnectionActivity} from "../../services/ClientsService";
import EntriesIterator from "../../components/EntriesIterator";
import Moment from 'react-moment';
import {CONFIG_PAGE_ROWS} from "../../constants/constants";
import {Icon, Table} from 'antd';
import DialogTextInputFilter from "../../components/DialogTextInputFilter";

class ConnectionHistory extends EntriesIterator {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            page: 0,
            rows: CONFIG_PAGE_ROWS,
            total: 0
        }
    }

    processPaginatedRequest = (page, rows, filters) => {
        return getConnectionActivity(page, rows, filters);
    };

    renderAdditionalColumns() {
        return null;
    }

    renderView() {
        const columns = [{
            title: 'Estado',
            dataIndex: 'state',
            key: 'state',
            width: '5em',
            align: 'center',
            render: type => <Icon style={{color: type ? '#008' : 'red'}} type={type ? 'check-circle' : 'warning'}/>,
        }, {
            title: 'Fecha',
            dataIndex: 'date',
            key: 'date',
            render: date => <Moment date={date} format="DD/MM/YYYY"/>
        }, {
            title: 'Hora',
            dataIndex: 'date',
            key: 'hour',
            render: date => <Moment date={date} format="hh:mm:ss a"/>
        }, {
            title: 'Cliente',
            dataIndex: 'target',
            key: 'target',
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <DialogTextInputFilter
                    placeholder={'Cliente'}
                    selectedKeys={selectedKeys}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onSearch={this.handleFilterSearch(selectedKeys, confirm)}
                    onReset={this.handleFilterReset(clearFilters)}/>
            ),
        }];

        const moreColumns = this.renderAdditionalColumns();
        if (moreColumns != null) {
            columns.push(...moreColumns);
        }

        return <div>
            <h2 className="action-separator-x2">{'Historial de conexión'}</h2>
            <Table dataSource={this.state.data} columns={columns} bordered loading={this.state.loading}
                   pagination={this.getPagination()} size="small" onChange={this.handleStateChange} rowKey="id"/>
        </div>
    }
}

export default ConnectionHistory;


// WEBPACK FOOTER //
// ./src/app/views/clients/ConnectionHistory.js